import _ from 'underscore';

export class FluctuationLogService {
  constructor(fromScenario) {
    /*
    This is to help identify from which scenario the action happened. Currently it's only used
    for MCC performance fluctuation. We can enrich the scenarios if needed.
    */
    this.fromScenario = _.isEmpty(fromScenario) ? '' : `_${fromScenario}`;
  }

  logContext(fluctuation, fluxDate, eventType, userId, isInternal, activity, action, note) {
    const logObject = {
      fluxId: fluctuation.UniqueId,
      eventType,
      fluxContent: {
        actions: _.chain(fluctuation.Actions)
          .pluck('Messages')
          .flatten().pluck('MessageId')
          .value(),
        rootCauses: _.chain(fluctuation.RootCauses)
          .pluck('Message')
          .flatten().pluck('MessageId')
          .value(),
        description: fluctuation.Description.MessageId,
      },
      fluxDate,
      fluxKpi: fluctuation.FluctuationType,
      userId,
      isInternal,
      customerId: fluctuation.CustomerId,
      accountId: fluctuation.AccountId,
      campaignId: fluctuation.CampaignId,
      note,
    };
    activity
      .trace(
        `Fluctuationlog: ${JSON.stringify(logObject)}`,
        `${action}${this.fromScenario}`
      );
  }
}
